import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import BrandHeader from "@/components/BrandHeader";
import { TESTIDS } from "@/constants/testIds";
import { extractErrorMessage } from "@/lib/format";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("La contraseña debe tener al menos 8 caracteres");
      return;
    }
    if (password !== confirm) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña restablecida. Ya puedes iniciar sesión.");
      navigate("/");
    } catch (err) {
      toast.error(extractErrorMessage(err, "El token no es válido o ha expirado"));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#fafafa]" data-testid={TESTIDS.reset.root}>
      <BrandHeader
        right={
          <Link to="/" className="btn-ghost">
            <ArrowLeft className="w-4 h-4" /> Volver
          </Link>
        }
      />
      <main className="max-w-md mx-auto px-6 md:px-10 pt-16 pb-24">
        <div className="card fade-in-up">
          <h1 className="font-display text-2xl font-bold text-gray-900">Nueva contraseña</h1>
          {!token ? (
            <p className="mt-4 text-sm text-red-600">Token no encontrado en la URL.</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <label className="block">
                <span className="text-xs font-medium text-gray-600 mb-1.5 block">Nueva contraseña</span>
                <input
                  type="password"
                  required
                  minLength={8}
                  className="input-field"
                  placeholder="Mínimo 8 caracteres"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid={TESTIDS.reset.passwordInput}
                />
              </label>
              <label className="block">
                <span className="text-xs font-medium text-gray-600 mb-1.5 block">Confirmar contraseña</span>
                <input
                  type="password"
                  required
                  className="input-field"
                  placeholder="Repite la contraseña"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                />
              </label>
              <button
                type="submit"
                disabled={loading}
                className="btn-primary w-full"
                data-testid={TESTIDS.reset.submitBtn}
              >
                {loading ? "Restableciendo…" : "Restablecer contraseña"}
              </button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
